var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" "+_vm._s(_vm.expanded ? _vm.value : _vm.value.substr(0, 200) + '...')+" "),_c('a',{on:{"click":function($event){_vm.expanded = !_vm.expanded}}},[_vm._v(" "+_vm._s(_vm.expanded ? "See less" : "See more")+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }